import React, { ReactNode, useContext, useState } from "react";
import { ReactComponent as ChevronDownIcon } from "assets/icons/chevron-down-dark-gray.svg";
import { classNames } from "helpers/ClassNameHelper";
import { AccessibilityContext } from "views/AccessibilityContext";

interface AccordionProps {
    title?: string;
    children: React.ReactNode;
    className?: string;
    isBackground?: boolean;
    isOpenByDefault?: boolean;
    isButtonWithBorder?: boolean;
    afterTitleElement?: ReactNode;
    headerClassName?: string;
}

export const Accordion: React.FC<AccordionProps> = ({
    title,
    children,
    className,
    isBackground,
    isOpenByDefault,
    isButtonWithBorder,
    afterTitleElement,
    headerClassName,
}) => {
    const [isOpen, setIsOpen] = useState(isOpenByDefault);
    const { lowVision } = useContext(AccessibilityContext);

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className={classNames("accordion", className)}>
            <button
                className={classNames(
                    "accordion-header",
                    lowVision && "low-vision",
                    isOpen && "accordion-header--active",
                    isBackground && "background",
                    headerClassName
                )}
                onClick={toggleAccordion}
                aria-expanded={isOpen}
            >
                <div className="accordion-title">
                    {title && <span className="accordion-title-text">{title}</span>}
                    {afterTitleElement}
                </div>
                <div className={classNames(isButtonWithBorder && "accordion-icon-wrapper")}>
                    <ChevronDownIcon
                        className={classNames(
                            "accordion-icon",
                            isOpen && "accordion-icon--open",
                            lowVision && "low-vision-icon"
                        )}
                    />
                </div>
            </button>
            <div
                className={classNames("accordion-content", isOpen && "accordion-content--open")}
                aria-hidden={!isOpen}
            >
                {children}
            </div>
        </div>
    );
};
